import { ObjectSharing } from '../../object-sharing/object-sharing.model';
import { DeviceSharingActions, DeviceSharingActionTypes } from '../actions/device-sharing.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: ObjectSharing[];
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(
  state = initialState,
  action: DeviceSharingActions
): State {
  switch (action.type) {
    case DeviceSharingActionTypes.GetDeviceSharingList: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceSharingActionTypes.AddDeviceSharing: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceSharingActionTypes.UpdateDeviceSharing: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceSharingActionTypes.DeleteDeviceSharing: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceSharingActionTypes.LoadDeviceSharingList: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

